import { render, staticRenderFns } from "./shopTable.vue?vue&type=template&id=cf9fded8&scoped=true&"
import script from "./shopTable.vue?vue&type=script&lang=js&"
export * from "./shopTable.vue?vue&type=script&lang=js&"
import style0 from "./shopTable.vue?vue&type=style&index=0&id=cf9fded8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9fded8",
  null
  
)

export default component.exports